import * as React from 'react';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDateRangePicker } from '@mui/x-date-pickers-pro';
import { getValue } from '@mui/system';

const shortcutsItems = [
    {
        label: 'Today',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('day'), today.endOf('day')];
        },
    },
    {
        label: 'Yesterday',
        getValue: () => {
            const yesterday = dayjs().subtract(1, 'day');
            return [yesterday.startOf('day'), yesterday.endOf('day')];
        },
    },
    {
        label: 'Last Week',
        getValue: () => {
            const today = dayjs();
            const lastWeekStart = today.subtract(7, 'day').startOf('day');
            return [lastWeekStart, today.endOf('day')];
        },
    },
    {
        label: 'Last Month',
        getValue: () => {
            const today = dayjs();
            const lastMonthStart = today.subtract(1, 'month').startOf('day');
            return [lastMonthStart, today.endOf('day')];
        },
    },
    {
        label: 'Last Quarter',
        getValue: () => {
            const today = dayjs();
            const lastQuarterStart = today.subtract(3, 'month').startOf('day');
            return [lastQuarterStart, today.endOf('day')];
        },
    },
    {
        label: 'Reset',
        getValue: () => [null, null],
    },
];

export default function BasicRangeShortcuts() {
    return (
        <div className='date-picker-container'>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDateRangePicker
                    slotProps={{
                        shortcuts: {
                            items: shortcutsItems,

                        },
                        actionBar: { actions: [] },
                    }}
                    calendars={1}
                    disableFuture={true}
                />
            </LocalizationProvider>
        </div>

    );
}